import {observer} from 'mobx-react-lite'
import * as React from 'react'
import {Suspense, useEffect} from 'react'
import {Lang} from 'yougile-lang'
import {Util} from 'yougile-util'
import {CompanyLoginMain} from './company-login-main'
import {CompanyLoginRegister} from './company-login-register'
import {CompanyLoginRegisterFinish} from './company-login-register-finish'
import {CompanyLoginSentEmail} from './company-login-sent-email'
import {companyLoginStore} from './company-login-store'
import {Company} from './types'

// Тестировать ссылку на компанию на локали и тестинге так
// добавляем get параметр ?domain=имя домена

// Рассматриваются кейсы
// 1 Пользователь не залогинен и не зарегистрирован вообще и переходит по ссылке
// 2 Пользователь не залогинен и зарегистрирован в другой компании и переходит по ссылке
// 3 Пользователь не залогинен и зарегистрирован в этой компании и переходит по ссылке
// 4 Пользователь залогинен и зарегистрирован в другой компании и переходит по ссылке
// 5 Пользователь залогинен и зарегистрирован в этой компании и переходит по ссылке

const Login = React.lazy(() => import('../login'))

export const CompanyLogin = observer(() => {
  const bem = Util.bemFrom('company-login')
  const {company} = companyLoginStore.state

  useEffect(() => {
    if (!companyLoginStore.state.company) {
      void companyLoginStore.loader().then(c => {
        companyLoginStore.setCompany(c)
      })
    }
  }, [])

  const screen = getScreen(company)

  if (company && !company.fetchError && screen === 'enter') {
    return (
      <Suspense fallback={<div className={bem('loading')} />}>
        <Login company={company} />
      </Suspense>
    )
  }

  const content = {
    main: <CompanyLoginMain />,
    enter: null,
    register: <CompanyLoginRegister />,
    'sent-email': <CompanyLoginSentEmail />,
    'register-finish': <CompanyLoginRegisterFinish />
  }[screen]

  return (
    <div className={bem()}>
      <div className={bem('cnt')}>
        <div className={bem('logo')} />
        {!company && <div className={bem('loading')} />}
        {company?.fetchError ? (
          <div className={bem('not-found')}>
            {Lang.msg.permission.companyNotFound}
          </div>
        ) : (
          <>
            {!!company && (
              <div className={bem('name')}>
                {Lang.msg.common.company} “{company.name}”
              </div>
            )}
            {content}
          </>
        )}
      </div>
    </div>
  )
})

const getScreen = (company: Company | undefined) => {
  const notAccepted = (location.search || '').includes('not-accepted')
  if (notAccepted) {
    return 'register-finish'
  }

  return company?.regEmail ? 'enter' : companyLoginStore.state.screen
}
